import React, { useEffect, useState } from "react";
import "./Doctors.css";
import { Link } from "react-router-dom";
import { fetchJson } from "../../api";

const Doctors = () => {
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    let mounted = true;

    fetchJson("doctors").then((data) => {
      if (!mounted || !data || !Array.isArray(data.doctors)) return;

      const list = data.doctors.map((d) => ({
        id: d.id,
        name: d.name,
        designation: d.designation || "",
        image: d.image_url,
        description: d.description || "",
      }));

      if (list.length > 0) setDoctors(list);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="doctors-section">
      <div className="container">
        <div className="section-header">
          <h2>Meet Our Experts</h2>
          <p>
            Our experienced fertility experts are dedicated to providing
            compassionate and advanced reproductive care.
          </p>
        </div>

        <div className="doctors-grid">
          {doctors.length === 0 ? (
            <p style={{ gridColumn: "1 / -1", textAlign: "center", color: "var(--text-muted)" }}>
              No doctors available at the moment.
            </p>
          ) : (
            doctors.map((doctor) => (
              <div className="doctor-card" key={doctor.id}>
                <div className="doctor-image">
                  <img src={doctor.image} alt={doctor.name} />
                </div>

                <div className="doctor-content">
                  <h3>{doctor.name}</h3>
                  <span>{doctor.designation}</span>
                  <p>{doctor.description}</p>
                  <Link
                      to="/bookappointment"
                      className="btn btn-appointment"
                      title="Book IVF Appointment"
                    >
                      Book Appointment
                    </Link>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Doctors;